import api from '../api';

// Profile Management API endpoints
export const profileAPI = {
  // Get user profile data
  getUserProfile: (userId) => 
    api.get(`/users/${userId}`),

  // Update username
  updateUsername: (userId, username) => 
    api.patch(`/users/${userId}/username`, { username }),

  // Get user profile image
  getUserImage: (userId, token) => 
    api.get(`/user/${userId}/image`, {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    }),

  // Get user profile image by email
  getImageByEmail: (email) =>
    api.get(`/user/image-by-email/${encodeURIComponent(email)}`, {
      responseType: "blob",
    }),

  // Update user profile image
  updateUserImage: (userId, formData) => 
    api.patch(`/user/${userId}/image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // Delete/deactivate user account
  deactivateAccount: (userId) => 
    api.delete(`/${userId}`),

  // Get user transactions
  getUserTransactions: () => 
    api.get("/transactions"),

  // Get user thrifts
  getUserThrifts: () => 
    api.get("/thrifts"),
};

// KYC Management API endpoints
export const kycAPI = {
  // Get KYC data
  getKycData: () => 
    api.get("/getKyc"),

  // Update KYC information
  updateKyc: (kycData) => 
    api.post("/updateKyc", kycData),

  // Request verification code
  requestVerificationCode: (email, phone) => 
    api.post("/requestVerificationCode", { email, phone }),

  // Verify code
  verifyCode: (code) => 
    api.post("/verifyCode", { code }),
};

// Authentication and Security API endpoints
export const authAPI = {
  // Enable 2FA
  enable2FA: () => 
    api.post("/enable2FA"),

  // Disable 2FA
  disable2FA: () => 
    api.post("/disable2FA"),

  // Verify 2FA token
  verify2FA: (token) => 
    api.post("/verify2FA", { token }),

  // Generate 2FA QR code
  generate2FAQRCode: () => 
    api.get("/generate2FA"),
};

// Combined service for easier imports
export const profileService = {
  ...profileAPI,
  ...kycAPI,
  ...authAPI,
};

export default profileService;